<template>
  <div class="conditioning-service-detail">
    <!-- 导航栏 -->
    <header class="navbar">
      <div class="container" style="max-width: 100%;">
        <div class="logo">
          <img src="/hhwl.png" alt="北京和合网链科技有限公司" />
          <span>北京和合网链科技有限公司</span>
        </div>
        <nav class="nav-links">
          <router-link to="/" class="nav-link">首页</router-link>
          <router-link to="/health-detection" class="nav-link">健康检测</router-link>
          <router-link to="/health-management" class="nav-link">健康管理</router-link>
          <router-link to="/conditioning-service" class="nav-link" style="color: #3498db;">调理服务</router-link>
          <router-link to="/expert-team" class="nav-link">专家团队</router-link>
          <router-link to="/news" class="nav-link">行业资讯</router-link>
          <router-link to="/cases" class="nav-link">成功案例</router-link>
          <router-link to="/appointment-service" class="nav-link">预约服务</router-link>
        </nav>
        <div class="user-actions" style="width: 414.34px;"></div>
      </div>
    </header>

    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <div class="container">
        <router-link to="/">首页</router-link>
        <span class="separator">></span>
        <router-link to="/conditioning-service">调理服务</router-link>
        <span class="separator">></span>
        <span class="current">{{ service ? service.title : '服务详情' }}</span>
      </div>
    </div>

    <!-- 服务详情内容 -->
    <div class="service-detail-content" v-if="service">
      <div class="container">
        <!-- 服务头部 -->
        <div class="service-header">
          <div class="service-icon">
            <i :class="service.icon"></i>
          </div>
          <div class="service-info">
            <h1>{{ service.title }}</h1>
            <p class="service-description">{{ service.description }}</p>
            <div class="service-tags">
              <span v-for="tag in service.tags" :key="tag" class="tag">{{ tag }}</span>
            </div>
          </div>
          <div class="service-actions">
            <button @click="showBookingForm" class="btn-primary">立即预约</button>
            <button @click="goBack" class="btn-secondary">返回列表</button>
          </div>
        </div>

        <!-- 服务详情 -->
        <div class="service-body">
          <!-- 服务介绍 -->
          <div class="section">
            <h2 class="section-title">服务介绍</h2>
            <div class="section-content">
              <div class="intro-text">
                <p>{{ service.introduction }}</p>
              </div>
              <div class="intro-features">
                <div class="feature-grid">
                  <div v-for="feature in service.detailedFeatures" :key="feature.title" class="feature-item">
                    <div class="feature-icon">
                      <i :class="feature.icon"></i>
                    </div>
                    <h3>{{ feature.title }}</h3>
                    <p>{{ feature.description }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 调理原理 -->
          <div class="section">
            <h2 class="section-title">调理原理</h2>
            <div class="section-content">
              <div class="principle-content">
                <div class="principle-text">
                  <p>{{ service.principle }}</p>
                </div>
                <div class="principle-steps">
                  <div v-for="(step, index) in service.principleSteps" :key="index" class="principle-step">
                    <div class="step-number">{{ index + 1 }}</div>
                    <div class="step-content">
                      <h3>{{ step.title }}</h3>
                      <p>{{ step.description }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 服务流程 -->
          <div class="section">
            <h2 class="section-title">服务流程</h2>
            <div class="section-content">
              <div class="process-timeline">
                <div v-for="(item, index) in service.process" :key="index" class="timeline-item">
                  <div class="timeline-dot"></div>
                  <div class="timeline-content">
                    <h3>{{ item.title }}</h3>
                    <p>{{ item.description }}</p>
                    <div class="timeline-duration">{{ item.duration }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 适用人群 -->
          <div class="section">
            <h2 class="section-title">适用人群</h2>
            <div class="section-content">
              <div class="target-groups">
                <div v-for="group in service.targetGroups" :key="group.id" class="target-card">
                  <div class="target-icon">
                    <i :class="group.icon"></i>
                  </div>
                  <h3>{{ group.title }}</h3>
                  <p>{{ group.description }}</p>
                  <div class="target-symptoms">
                    <span v-for="symptom in group.symptoms" :key="symptom">{{ symptom }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 调理效果 -->
          <div class="section">
            <h2 class="section-title">调理效果</h2>
            <div class="section-content">
              <div class="effects-content">
                <div class="effects-chart">
                  <h3>效果统计</h3>
                  <div class="chart-item" v-for="effect in service.effects" :key="effect.item">
                    <div class="chart-label">{{ effect.item }}</div>
                    <div class="chart-bar">
                      <div class="chart-progress" :style="{ width: effect.percentage + '%' }"></div>
                    </div>
                    <div class="chart-value">{{ effect.percentage }}%</div>
                  </div>
                </div>
                <div class="effects-testimonials">
                  <h3>客户反馈</h3>
                  <div class="testimonial-item" v-for="testimonial in service.testimonials" :key="testimonial.id">
                    <div class="testimonial-content">
                      <p>"{{ testimonial.content }}"</p>
                      <div class="testimonial-author">
                        <strong>{{ testimonial.name }}</strong>
                        <span>{{ testimonial.role }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 相关服务 -->
          <div class="section">
            <h2 class="section-title">相关服务</h2>
            <div class="section-content">
              <div class="related-services">
                <div v-for="relatedService in relatedServices" :key="relatedService.id" class="related-service-card" @click="viewService(relatedService)">
                  <div class="service-icon">
                    <i :class="relatedService.icon"></i>
                  </div>
                  <h3>{{ relatedService.title }}</h3>
                  <p>{{ relatedService.description }}</p>
                  <button class="view-btn">查看详情</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 预约表单弹窗 -->
    <div class="booking-modal" v-if="showBooking">
      <div class="modal-overlay" @click="closeBookingForm"></div>
      <div class="modal-content">
        <div class="modal-header">
          <h3>预约{{ service.title }}</h3>
          <button @click="closeBookingForm" class="close-btn">
            <i class="el-icon-close"></i>
          </button>
        </div>
        <div class="modal-body">
          <el-form :model="bookingForm" :rules="bookingRules" ref="bookingForm" label-width="100px">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="bookingForm.name" placeholder="请输入您的姓名"></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="phone">
              <el-input v-model="bookingForm.phone" placeholder="请输入您的联系电话"></el-input>
            </el-form-item>
            <el-form-item label="预约时间" prop="date">
              <el-date-picker
                v-model="bookingForm.date"
                type="datetime"
                placeholder="选择预约时间"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm"
                style="width: 100%">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="健康状况" prop="health">
              <el-input type="textarea" v-model="bookingForm.health" :rows="3" placeholder="请简要描述您的健康状况或调理需求"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="modal-footer">
          <button @click="closeBookingForm" class="btn-cancel">取消</button>
          <button @click="submitBooking" class="btn-primary">确认预约</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConditioningServiceDetail',
  data() {
    return {
      service: null,
      relatedServices: [],
      showBooking: false,
      bookingForm: {
        name: '',
        phone: '',
        date: '',
        health: ''
      },
      bookingRules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        date: [
          { required: true, message: '请选择预约时间', trigger: 'change' }
        ],
        health: [
          { required: true, message: '请描述您的健康状况', trigger: 'blur' }
        ]
      },
      // 服务数据
      services: {
        1: {
          id: 1,
          title: '量子能量调理',
          icon: 'el-icon-lightning',
          description: '运用量子共振技术，调节身体能量场，恢复生命活力',
          tags: ['能量平衡', '经络疏通', '气血调理', '免疫力提升'],
          introduction: '量子能量调理是基于量子物理学原理开发的创新健康调理技术。通过运用先进的量子共振设备，我们能够精准识别身体能量场的失衡状态，并发射特定的量子频率来调节和平衡身体的能量系统。',
          detailedFeatures: [
            {
              title: '能量平衡调节',
              icon: 'el-icon-balance',
              description: '通过量子共振技术调节身体生物能量场，恢复能量的平衡状态'
            },
            {
              title: '经络疏通',
              icon: 'el-icon-connection',
              description: '运用量子频率疏通经络阻塞，促进气血畅通运行'
            },
            {
              title: '气血调理',
              icon: 'el-icon-heart',
              description: '调节气血运行，改善血液循环，提升组织供氧能力'
            },
            {
              title: '免疫力提升',
              icon: 'el-icon-shield',
              description: '激活免疫系统功能，增强身体抵抗疾病的能力'
            }
          ],
          principle: '量子能量调理基于量子纠缠和共振原理。每个细胞都有其独特的量子振动频率，当身体出现能量失衡时，细胞的振动频率会发生改变。通过量子设备发射特定的修复频率，可以重新调节细胞的振动状态，恢复正常的能量平衡。',
          principleSteps: [
            {
              title: '量子检测',
              description: '运用量子共振设备检测身体能量场状态，识别失衡区域'
            },
            {
              title: '频率分析',
              description: '分析检测数据，确定需要调理的频率和强度'
            },
            {
              title: '能量调节',
              description: '通过量子设备发射特定频率，调节身体能量场'
            },
            {
              title: '效果监测',
              description: '实时监测调理效果，及时调整调理方案'
            }
          ],
          process: [
            {
              title: '健康评估',
              description: '全面的健康状况评估和量子检测',
              duration: '30-60分钟'
            },
            {
              title: '方案制定',
              description: '根据检测结果制定个性化调理方案',
              duration: '20-30分钟'
            },
            {
              title: '调理实施',
              description: '专业调理师进行量子能量调理',
              duration: '60-90分钟'
            },
            {
              title: '效果评估',
              description: '调理后效果评估和后续建议',
              duration: '15-20分钟'
            }
          ],
          targetGroups: [
            {
              id: 1,
              title: '亚健康人群',
              icon: 'el-icon-user',
              description: '长期处于亚健康状态，需要全面调理的人群',
              symptoms: ['疲劳乏力', '失眠多梦', '注意力不集中', '免疫力低下']
            },
            {
              id: 2,
              title: '慢性病患者',
              icon: 'el-icon-warning',
              description: '患有各种慢性疾病，需要辅助调理的人群',
              symptoms: ['高血压', '糖尿病', '关节炎', '消化不良']
            }
          ],
          effects: [
            { item: '能量水平提升', percentage: 95 },
            { item: '睡眠质量改善', percentage: 92 },
            { item: '疲劳感缓解', percentage: 88 },
            { item: '免疫力提升', percentage: 85 },
            { item: '整体健康改善', percentage: 90 }
          ],
          testimonials: [
            {
              id: 1,
              content: '量子能量调理让我重新找回了活力，精神状态比以前好太多了。',
              name: '张女士',
              role: '公司白领'
            },
            {
              id: 2,
              content: '经过几次调理，我的亚健康状态得到了明显改善，工作效率也提高了。',
              name: '李先生',
              role: 'IT工程师'
            }
          ]
        },
        2: {
          id: 2,
          title: '量子细胞修复',
          icon: 'el-icon-magic-stick',
          description: '通过量子频率激活细胞自我修复能力，延缓衰老',
          tags: ['细胞活化', 'DNA修复', '抗氧化', '再生能力'],
          introduction: '量子细胞修复是运用量子生物学原理开发的前沿抗衰老技术。通过特定的量子频率激活细胞的自我修复机制，促进DNA修复和细胞再生，从根本上延缓衰老过程。',
          detailedFeatures: [
            {
              title: '细胞活化',
              icon: 'el-icon-cpu',
              description: '激活休眠细胞，提升细胞活性和代谢能力'
            },
            {
              title: 'DNA修复',
              icon: 'el-icon-document-copy',
              description: '促进DNA损伤修复，维持基因稳定性'
            },
            {
              title: '抗氧化',
              icon: 'el-icon-magic-stick',
              description: '增强抗氧化能力，减少自由基损伤'
            },
            {
              title: '再生能力提升',
              icon: 'el-icon-refresh',
              description: '激活干细胞活性，促进组织再生修复'
            }
          ],
          principle: '量子细胞修复基于量子生物学理论。细胞内的生物分子都有其特定的量子振动频率，当这些频率受到外界环境因素影响而发生改变时，细胞功能就会受损。通过施加正确的量子频率，可以恢复分子的正常振动，激活细胞的自我修复机制。',
          principleSteps: [
            {
              title: '细胞状态检测',
              description: '运用量子设备检测细胞振动频率和能量状态'
            },
            {
              title: '损伤识别',
              description: '识别细胞损伤程度和修复需求'
            },
            {
              title: '修复频率施加',
              description: '施加特定的量子修复频率，激活细胞修复机制'
            },
            {
              title: '再生促进',
              description: '促进细胞分裂和再生，加速组织修复'
            }
          ],
          process: [
            {
              title: '细胞检测',
              description: '量子细胞状态检测和评估',
              duration: '45-60分钟'
            },
            {
              title: '修复方案',
              description: '制定个性化细胞修复方案',
              duration: '30分钟'
            },
            {
              title: '修复实施',
              description: '进行量子细胞修复治疗',
              duration: '90-120分钟'
            },
            {
              title: '效果评估',
              description: '评估修复效果和调整方案',
              duration: '30分钟'
            }
          ],
          targetGroups: [
            {
              id: 1,
              title: '中老年人群',
              icon: 'el-icon-time',
              description: '进入中老年，需要抗衰老和细胞修复的人群',
              symptoms: ['体力下降', '记忆力减退', '皮肤老化', '免疫力下降']
            },
            {
              id: 2,
              title: '病后康复',
              icon: 'el-icon-first-aid-kit',
              description: '疾病后需要细胞修复和功能恢复的人群',
              symptoms: ['体力不支', '恢复缓慢', '免疫功能低下', '组织损伤']
            }
          ],
          effects: [
            { item: '细胞活性提升', percentage: 93 },
            { item: '皮肤状态改善', percentage: 88 },
            { item: '体力增强', percentage: 85 },
            { item: '记忆力改善', percentage: 78 },
            { item: '抗衰老效果', percentage: 90 }
          ],
          testimonials: [
            {
              id: 1,
              content: '细胞修复治疗后，我的皮肤状态明显改善，看起来年轻了好几岁。',
              name: '王女士',
              role: '教师'
            },
            {
              id: 2,
              content: '病后恢复很快，体力明显提升，量子细胞修复真的很神奇。',
              name: '陈先生',
              role: '退休干部'
            }
          ]
        },
        3: {
          id: 3,
          title: '量子情绪调理',
          icon: 'el-icon-heart',
          description: '调节情绪能量频率，缓解压力，改善心理健康',
          tags: ['压力释放', '情绪平衡', '睡眠改善', '焦虑缓解'],
          introduction: '量子情绪调理是基于神经量子物理学开发的情绪健康技术。通过调节大脑和神经系统的量子振动频率，平衡情绪状态，缓解压力和焦虑，改善睡眠质量。',
          detailedFeatures: [
            {
              title: '压力释放',
              icon: 'el-icon-release',
              description: '释放深层的压力和紧张，恢复身心平衡'
            },
            {
              title: '情绪平衡',
              icon: 'el-icon-balance',
              description: '调节情绪波动，保持情绪稳定和谐'
            },
            {
              title: '睡眠改善',
              icon: 'el-icon-moon',
              description: '改善睡眠质量，解决失眠问题'
            },
            {
              title: '焦虑缓解',
              icon: 'el-icon-sunny',
              description: '缓解焦虑症状，提升心理健康水平'
            }
          ],
          principle: '情绪和思维本质上是一种量子振动现象。当人处于压力、焦虑等负面情绪状态时，大脑神经元的量子振动频率会发生紊乱。通过施加特定的和谐频率，可以重新调节神经系统的量子振动，恢复情绪的正常状态。',
          principleSteps: [
            {
              title: '情绪状态评估',
              description: '评估当前情绪状态和压力水平'
            },
            {
              title: '频率检测',
              description: '检测大脑和神经系统的量子振动频率'
            },
            {
              title: '情绪调节',
              description: '施加和谐频率，调节情绪能量状态'
            },
            {
              title: '状态稳定',
              description: '巩固调理效果，建立新的情绪平衡'
            }
          ],
          process: [
            {
              title: '情绪评估',
              description: '心理健康评估和情绪状态分析',
              duration: '30-45分钟'
            },
            {
              title: '频率检测',
              description: '量子情绪频率检测和分析',
              duration: '20-30分钟'
            },
            {
              title: '调理实施',
              description: '进行量子情绪调理治疗',
              duration: '60-90分钟'
            },
            {
              title: '效果巩固',
              description: '巩固调理效果，提供自我调节技巧',
              duration: '30分钟'
            }
          ],
          targetGroups: [
            {
              id: 1,
              title: '职场高压人群',
              icon: 'el-icon-office-building',
              description: '工作压力大，需要情绪管理的职场人士',
              symptoms: ['压力过大', '焦虑紧张', '情绪波动', '职业倦怠']
            },
            {
              id: 2,
              title: '情绪障碍人群',
              icon: 'el-icon-user',
              description: '有情绪困扰，需要专业调理的人群',
              symptoms: ['抑郁倾向', '焦虑症状', '失眠问题', '情绪不稳定']
            }
          ],
          effects: [
            { item: '压力水平降低', percentage: 92 },
            { item: '睡眠质量改善', percentage: 89 },
            { item: '情绪稳定性', percentage: 86 },
            { item: '焦虑缓解', percentage: 84 },
            { item: '心理健康', percentage: 88 }
          ],
          testimonials: [
            {
              id: 1,
              content: '情绪调理帮助我走出了职场焦虑，现在工作生活都平衡了很多。',
              name: '刘女士',
              role: '企业经理'
            },
            {
              id: 2,
              content: '长期的失眠问题得到了解决，精神状态比以前好太多了。',
              name: '赵先生',
              role: '程序员'
            }
          ]
        },
        4: {
          id: 4,
          title: '量子排毒调理',
          icon: 'el-icon-refresh',
          description: '促进体内毒素排出，净化身体内环境',
          tags: ['肝脏排毒', '肠道净化', '重金属排除', '代谢优化'],
          introduction: '量子排毒调理运用量子共振原理激活身体的排毒系统，促进毒素的识别、分解和排出。通过调节细胞膜的量子通透性，增强排毒器官的功能，净化身体内环境。',
          detailedFeatures: [
            {
              title: '肝脏排毒',
              icon: 'el-icon-s-operation',
              description: '激活肝脏解毒酶系统，增强肝脏排毒功能'
            },
            {
              title: '肠道净化',
              icon: 'el-icon-document',
              description: '清洁肠道内环境，改善肠道菌群平衡'
            },
            {
              title: '重金属排除',
              icon: 'el-icon-remove',
              description: '促进重金属离子螯合和排出'
            },
            {
              title: '代谢优化',
              icon: 'el-icon-cpu',
              description: '优化新陈代谢，提升毒素处理能力'
            }
          ],
          principle: '毒素在体内会干扰细胞的正常量子振动。量子排毒调理通过施加特定的排毒频率，可以重新激活细胞和器官的排毒功能，增强毒素的识别和排出能力，恢复身体的内环境平衡。',
          principleSteps: [
            {
              title: '毒素检测',
              description: '检测体内毒素水平和排毒系统状态'
            },
            {
              title: '排毒激活',
              description: '激活排毒器官的量子振动频率'
            },
            {
              title: '毒素排出',
              description: '促进毒素的分解、螯合和排出'
            },
            {
              title: '环境净化',
              description: '净化身体内环境，建立新的平衡'
            }
          ],
          process: [
            {
              title: '毒素评估',
              description: '体内毒素水平和排毒功能评估',
              duration: '45-60分钟'
            },
            {
              title: '排毒方案',
              description: '制定个性化排毒调理方案',
              duration: '30分钟'
            },
            {
              title: '排毒实施',
              description: '进行量子排毒调理治疗',
              duration: '90-120分钟'
            },
            {
              title: '效果评估',
              description: '评估排毒效果和后续维护',
              duration: '30分钟'
            }
          ],
          targetGroups: [
            {
              id: 1,
              title: '环境污染暴露人群',
              icon: 'el-icon-warning',
              description: '长期暴露在污染环境中，需要排毒的人群',
              symptoms: ['疲劳乏力', '皮肤问题', '消化不良', '免疫力下降']
            },
            {
              id: 2,
              title: '不良生活习惯人群',
              icon: 'el-icon-user',
              description: '有不良生活习惯，需要身体净化的人群',
              symptoms: ['体内毒素积累', '代谢缓慢', '亚健康状态', '器官负担重']
            }
          ],
          effects: [
            { item: '毒素排出', percentage: 90 },
            { item: '代谢改善', percentage: 87 },
            { item: '精力提升', percentage: 85 },
            { item: '皮肤改善', percentage: 82 },
            { item: '整体健康', percentage: 88 }
          ],
          testimonials: [
            {
              id: 1,
              content: '排毒调理后，皮肤状态明显改善，感觉整个人都轻松了。',
              name: '孙女士',
              role: '美容师'
            },
            {
              id: 2,
              content: '长期的消化不良问题得到了解决，精神状态也好了很多。',
              name: '周先生',
              role: '销售经理'
            }
          ]
        },
        5: {
          id: 5,
          title: '量子疼痛调理',
          icon: 'el-icon-first-aid-kit',
          description: '非侵入性疼痛管理，快速缓解各种急慢性疼痛',
          tags: ['疼痛缓解', '炎症消除', '组织修复', '功能恢复'],
          introduction: '量子疼痛调理运用量子共振原理进行非侵入性疼痛管理。通过调节疼痛信号传导的量子频率，阻断疼痛感知，同时促进组织修复和功能恢复，达到标本兼治的效果。',
          detailedFeatures: [
            {
              title: '疼痛缓解',
              icon: 'el-icon-remove-outline',
              description: '快速缓解各种急慢性疼痛，无需药物'
            },
            {
              title: '炎症消除',
              icon: 'el-icon-cold-drink',
              description: '减轻炎症反应，促进组织消肿'
            },
            {
              title: '组织修复',
              icon: 'el-icon-magic-stick',
              description: '促进受损组织修复和再生'
            },
            {
              title: '功能恢复',
              icon: 'el-icon-refresh',
              description: '恢复受损部位的正常功能'
            }
          ],
          principle: '疼痛本质上是一种神经信号的量子振动现象。通过量子技术可以调节疼痛信号的传导频率，阻断疼痛感知。同时，特定的修复频率可以促进组织细胞的修复过程，从根本上解决疼痛问题。',
          principleSteps: [
            {
              title: '疼痛评估',
              description: '评估疼痛类型、程度和原因'
            },
            {
              title: '频率调节',
              description: '调节疼痛信号传导的量子频率'
            },
            {
              title: '修复促进',
              description: '促进组织修复和功能恢复'
            },
            {
              title: '效果巩固',
              description: '巩固调理效果，预防复发'
            }
          ],
          process: [
            {
              title: '疼痛评估',
              description: '疼痛类型分析和程度评估',
              duration: '30-45分钟'
            },
            {
              title: '调理方案',
              description: '制定个性化疼痛调理方案',
              duration: '20-30分钟'
            },
            {
              title: '调理实施',
              description: '进行量子疼痛调理治疗',
              duration: '60-90分钟'
            },
            {
              title: '功能训练',
              description: '功能恢复训练和效果巩固',
              duration: '30-45分钟'
            }
          ],
          targetGroups: [
            {
              id: 1,
              title: '慢性疼痛患者',
              icon: 'el-icon-user',
              description: '长期受慢性疼痛困扰的患者',
              symptoms: ['关节疼痛', '肌肉酸痛', '神经痛', '慢性头痛']
            },
            {
              id: 2,
              title: '运动损伤人群',
              icon: 'el-icon-basketball',
              description: '运动损伤后需要疼痛管理和功能恢复的人群',
              symptoms: ['急性损伤', '软组织损伤', '关节扭伤', '肌肉拉伤']
            }
          ],
          effects: [
            { item: '疼痛缓解', percentage: 94 },
            { item: '功能改善', percentage: 88 },
            { item: '炎症减轻', percentage: 86 },
            { item: '生活质量', percentage: 91 },
            { item: '活动能力', percentage: 87 }
          ],
          testimonials: [
            {
              id: 1,
              content: '长期的颈椎疼痛问题得到了很好的缓解，现在可以正常工作了。',
              name: '吴先生',
              role: 'IT工程师'
            },
            {
              id: 2,
              content: '运动损伤后的疼痛管理效果很好，恢复比预期快很多。',
              name: '郑女士',
              role: '运动员'
            }
          ]
        },
        6: {
          id: 6,
          title: '量子美容调理',
          icon: 'el-icon-star-on',
          description: '从内而外改善肌肤状态，重现青春光彩',
          tags: ['肌肤紧致', '皱纹淡化', '色斑消除', '容光焕发'],
          introduction: '量子美容调理运用量子生物物理学原理，从细胞层面改善肌肤状态。通过调节皮肤细胞的量子振动频率，促进胶原蛋白合成，改善血液循环，达到从内而外的美容效果。',
          detailedFeatures: [
            {
              title: '肌肤紧致',
              icon: 'el-icon-thumb',
              description: '提升肌肤弹性，恢复紧致状态'
            },
            {
              title: '皱纹淡化',
              icon: 'el-icon-edit-outline',
              description: '促进胶原蛋白合成，淡化细纹皱纹'
            },
            {
              title: '色斑消除',
              icon: 'el-icon-picture-outline',
              description: '调节色素代谢，淡化色斑'
            },
            {
              title: '容光焕发',
              icon: 'el-icon-sunny',
              description: '改善肌肤光泽，重现健康光彩'
            }
          ],
          principle: '皮肤的状态与细胞的量子振动频率密切相关。当皮肤细胞振动频率降低时，会出现老化、色斑等问题。通过量子美容调理可以重新激活皮肤细胞的正常振动，促进细胞更新和胶原蛋白合成，改善肌肤状态。',
          principleSteps: [
            {
              title: '肌肤检测',
              description: '检测肌肤状态和细胞振动频率'
            },
            {
              title: '美容频率',
              description: '施加特定的美容量子频率'
            },
            {
              title: '细胞激活',
              description: '激活皮肤细胞，促进更新修复'
            },
            {
              title: '效果巩固',
              description: '巩固美容效果，维持肌肤状态'
            }
          ],
          process: [
            {
              title: '肌肤评估',
              description: '肌肤状态分析和问题诊断',
              duration: '30-45分钟'
            },
            {
              title: '美容方案',
              description: '制定个性化量子美容方案',
              duration: '20-30分钟'
            },
            {
              title: '美容实施',
              description: '进行量子美容调理治疗',
              duration: '60-90分钟'
            },
            {
              title: '效果护理',
              description: '效果巩固和日常护理指导',
              duration: '30分钟'
            }
          ],
          targetGroups: [
            {
              id: 1,
              title: '肌肤老化人群',
              icon: 'el-icon-time',
              description: '出现肌肤老化迹象，需要抗衰老的人群',
              symptoms: ['细纹皱纹', '肌肤松弛', '色斑', '暗沉无光']
            },
            {
              id: 2,
              title: '美容保养人群',
              icon: 'el-icon-star-on',
              description: '希望改善肌肤状态，进行美容保养的人群',
              symptoms: ['肌肤粗糙', '毛孔粗大', '肤色不均', '缺乏光泽']
            }
          ],
          effects: [
            { item: '肌肤紧致', percentage: 89 },
            { item: '皱纹淡化', percentage: 86 },
            { item: '色斑改善', percentage: 83 },
            { item: '肌肤光泽', percentage: 87 },
            { item: '整体满意度', percentage: 90 }
          ],
          testimonials: [
            {
              id: 1,
              content: '量子美容调理让我的肌肤状态明显改善，看起来年轻了好几岁。',
              name: '林女士',
              role: '模特'
            },
            {
              id: 2,
              content: '长期的色斑问题得到了很好的改善，肌肤现在很有光泽。',
              name: '黄女士',
              role: '主持人'
            }
          ]
        }
      }
    }
  },
  mounted() {
    this.loadService()
  },
  watch: {
    '$route.query.id'(e) {
      if(e){
        this.loadService()
      }
    }
  },
  methods: {
    loadService() {
     const serviceId = this.$route.query.id
      this.service = this.services[serviceId]
      
      if (!this.service) {
        // 不再强制跳转，而是显示错误信息或使用默认服务
        console.warn(`未找到ID为 ${serviceId} 的服务，将显示默认服务`)
        // 使用第一个服务作为默认服务
        const serviceIds = Object.keys(this.services)
        if (serviceIds.length > 0) {
          this.service = this.services[serviceIds[0]]
          // 更新URL但不触发路由变化
          this.$router.replace({ query: { id: serviceIds[0] } })
        }
        return
      }
      
      // 获取相关服务
      this.relatedServices = Object.values(this.services)
        .filter(s => s.id !== parseInt(serviceId))
        .slice(0, 3)
    },
    viewService(service) {
      this.$router.push({
        path: '/conditioning-service-detail',
        query: { id: service.id }
      })
    },
    goBack() {
      this.$router.push('/conditioning-service')
    },
    showBookingForm() {
      // this.showBooking = true
      this.$router.push({
        path: '/',
        query: { type: 'appointment' }
      })
    },
    closeBookingForm() {
      this.showBooking = false
    },
    submitBooking() {
      this.$refs.bookingForm.validate((valid) => {
        if (valid) {
          this.$message.success('预约提交成功！我们会尽快与您联系。')
          this.closeBookingForm()
          this.resetForm()
        } else {
          this.$message.error('请完善预约信息')
        }
      })
    },
    resetForm() {
      this.bookingForm = {
        name: '',
        phone: '',
        date: '',
        health: ''
      }
    },
    // 结果反馈
    handleFeedBack() {
      this.$message.info('请前往个人中心查看检测结果反馈')
    },
    // 查看预约
    handleReservationConditioning() {
      this.$message.info('请前往个人中心查看预约记录')
    },
    // 预约状态
    reservationPromptClick() {
      this.$message.info('请前往个人中心查看预约状态')
    },
    // 获取手机号
    phone() {
      return null // 模拟未登录状态
    },
    // 显示PDF
    showPdf() {
      this.$message.info('检测结果PDF功能开发中...')
    }
  }
}
</script>

<style lang="scss" scoped>
/* 导航栏样式 */
.navbar {
  background-color: rgba(255, 255, 255, 0.95);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  transition: all 0.3s ease;
}

.navbar {
  padding: 0 20px;
}

.navbar .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  width: 100%;
}

.logo {
  width: 414.34px;
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  font-weight: bold;
  color: #2c3e50;
  
  img {
    height: 40px;
    margin-right: 8px;
  }
}

.nav-links {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  flex: 1;
  flex-wrap: wrap;
  padding: 0.5rem 1rem;
  align-items: center;
  
  a, .nav-link {
    color: #2c3e50;
    text-decoration: none;
    font-weight: 500;
    transition: all 0.3s ease;
    padding: 0.5rem 0;
    position: relative;
    white-space: nowrap;
    font-size: 0.95rem;
    cursor: pointer;
    
    &:hover,
    &.active,
    &.router-link-exact-active {
      color: #3498db;
    }
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 2px;
      background-color: #3498db;
      transition: width 0.3s ease;
    }
    
    &:hover::after,
    &.active::after {
      width: 100%;
    }
    
    &.btn-accent {
      background-color: #3498db;
      color: white;
      padding: 0.6rem 1.8rem;
      border-radius: 25px;
      font-weight: 600;
      box-shadow: 0 2px 8px rgba(52, 152, 219, 0.3);
      
      &:hover {
        background-color: #2980b9;
        color: white;
        box-shadow: 0 4px 12px rgba(41, 128, 185, 0.4);
        transform: translateY(-1px);
      }
      
      &::after {
        display: none;
      }
    }
  }
}


/* 面包屑导航 */
.breadcrumb {
  background: white;
  padding: 5px 0;
  border-bottom: 1px solid #eee;
}

.breadcrumb .container {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #666;
  padding-left: 10px;
}

.breadcrumb a {
  color: #666;
  text-decoration: none;
}

.breadcrumb a:hover {
  color: #1890ff;
}

.separator {
  color: #999;
}

.current {
  color: #1890ff;
}

/* 服务详情内容 */
.service-detail-content {
  padding: 40px 0;
  background: #f8f9fa;
  min-height: 100vh;
}

.service-detail-content .container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 服务头部 */
.service-header {
  background: white;
  padding: 40px;
  border-radius: 15px;
  box-shadow: 0 5px 20px rgba(0,0,0,0.08);
  display: flex;
  gap: 30px;
  align-items: center;
  margin-bottom: 40px;
}

.service-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #1890FF, #40a9ff);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 36px;
}

.service-info {
  flex: 1;
}

.service-info h1 {
  font-size: 32px;
  color: #333;
  margin-bottom: 15px;
}

.service-description {
  font-size: 16px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 20px;
}

.service-tags {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.tag {
  background: #e6f7ff;
  color: #1890FF;
  padding: 6px 12px;
  border-radius: 15px;
  font-size: 12px;
  font-weight: 500;
}

.service-actions {
  display: flex;
  gap: 15px;
  flex-direction: column;
}

.btn-primary {
  background: linear-gradient(135deg, #1890FF, #40a9ff);
  color: white;
  border: none;
  padding: 15px 30px;
  border-radius: 25px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(24,144,255,0.3);
}

.btn-secondary {
  background: white;
  color: #1890FF;
  border: 2px solid #1890FF;
  padding: 13px 30px;
  border-radius: 25px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.btn-secondary:hover {
  background: #1890FF;
  color: white;
}

/* 服务详情 */
.service-body {
  background: white;
  border-radius: 15px;
  box-shadow: 0 5px 20px rgba(0,0,0,0.08);
  overflow: hidden;
}

.section {
  padding: 40px;
  border-bottom: 1px solid #f0f0f0;
}

.section:last-child {
  border-bottom: none;
}

.section-title {
  font-size: 24px;
  color: #333;
  margin-bottom: 30px;
  position: relative;
  padding-left: 20px;
}

.section-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 24px;
  background: #1890FF;
  border-radius: 2px;
}

/* 服务介绍 */
.intro-text {
  margin-bottom: 30px;
}

.intro-text p {
  font-size: 16px;
  color: #666;
  line-height: 1.8;
  text-align: justify;
}

.feature-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
}

.feature-item {
  text-align: center;
  padding: 30px 20px;
  background: #f8f9fa;
  border-radius: 10px;
  transition: all 0.3s ease;
}

.feature-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}

.feature-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #1890FF, #40a9ff);
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
  margin: 0 auto 20px;
}

.feature-item h3 {
  font-size: 18px;
  color: #333;
  margin-bottom: 15px;
}

.feature-item p {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
}

/* 调理原理 */
.principle-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  align-items: start;
}

.principle-text p {
  font-size: 16px;
  color: #666;
  line-height: 1.8;
  text-align: justify;
}

.principle-steps {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.principle-step {
  display: flex;
  gap: 15px;
  align-items: start;
}

.step-number {
  width: 30px;
  height: 30px;
  background: #1890FF;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  flex-shrink: 0;
}

.step-content h3 {
  font-size: 16px;
  color: #333;
  margin-bottom: 8px;
}

.step-content p {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
}

/* 服务流程 */
.process-timeline {
  position: relative;
  padding-left: 30px;
}

.process-timeline::before {
  content: '';
  position: absolute;
  left: 15px;
  top: 0;
  bottom: 0;
  width: 2px;
  background: #1890FF;
}

.timeline-item {
  position: relative;
  margin-bottom: 40px;
}

.timeline-dot {
  position: absolute;
  left: -22px;
  top: 5px;
  width: 12px;
  height: 12px;
  background: #1890FF;
  border-radius: 50%;
  border: 3px solid white;
  box-shadow: 0 0 0 3px rgba(24,144,255,0.2);
}

.timeline-content h3 {
  font-size: 18px;
  color: #333;
  margin-bottom: 10px;
}

.timeline-content p {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 8px;
}

.timeline-duration {
  font-size: 12px;
  color: #1890FF;
  font-weight: 500;
}

/* 适用人群 */
.target-groups {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.target-card {
  background: #f8f9fa;
  padding: 30px;
  border-radius: 10px;
  text-align: center;
  transition: all 0.3s ease;
}

.target-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}

.target-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #1890FF, #40a9ff);
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
  margin: 0 auto 20px;
}

.target-card h3 {
  font-size: 18px;
  color: #333;
  margin-bottom: 15px;
}

.target-card p {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 20px;
}

.target-symptoms {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
}

.target-symptoms span {
  background: white;
  color: #1890FF;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  border: 1px solid #1890FF;
}

/* 调理效果 */
.effects-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
}

.effects-chart h3,
.effects-testimonials h3 {
  font-size: 18px;
  color: #333;
  margin-bottom: 20px;
}

.chart-item {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 15px;
}

.chart-label {
  width: 100px;
  font-size: 14px;
  color: #666;
}

.chart-bar {
  flex: 1;
  height: 8px;
  background: #f0f0f0;
  border-radius: 4px;
  overflow: hidden;
}

.chart-progress {
  height: 100%;
  background: linear-gradient(90deg, #1890FF, #40a9ff);
  border-radius: 4px;
  transition: width 1s ease;
}

.chart-value {
  width: 40px;
  text-align: right;
  font-size: 14px;
  color: #1890FF;
  font-weight: 500;
}

.testimonial-item {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 10px;
  margin-bottom: 15px;
}

.testimonial-content p {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  font-style: italic;
  margin-bottom: 15px;
}

.testimonial-author {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.testimonial-author strong {
  color: #333;
  font-size: 14px;
}

.testimonial-author span {
  color: #999;
  font-size: 12px;
}

/* 相关服务 */
.related-services {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
}

.related-service-card {
  background: #f8f9fa;
  padding: 30px;
  border-radius: 10px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.related-service-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}

.related-service-card .service-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #1890FF, #40a9ff);
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
  margin: 0 auto 20px;
}

.related-service-card h3 {
  font-size: 18px;
  color: #333;
  margin-bottom: 15px;
}

.related-service-card p {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 20px;
}

.view-btn {
  background: white;
  color: #1890FF;
  border: 1px solid #1890FF;
  padding: 8px 20px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s ease;
}

.view-btn:hover {
  background: #1890FF;
  color: white;
}

/* 预约表单弹窗 */
.booking-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
}

.modal-content {
  position: relative;
  background: white;
  border-radius: 15px;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 30px rgba(0,0,0,0.3);
}

.modal-header {
  padding: 20px 30px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h3 {
  font-size: 20px;
  color: #333;
  margin: 0;
}

.close-btn {
  background: none;
  border: none;
  font-size: 20px;
  color: #999;
  cursor: pointer;
  padding: 5px;
}

.close-btn:hover {
  color: #333;
}

.modal-body {
  padding: 30px;
}

.modal-footer {
  padding: 20px 30px;
  border-top: 1px solid #f0f0f0;
  display: flex;
  justify-content: flex-end;
  gap: 15px;
}

.btn-cancel {
  background: white;
  color: #666;
  border: 1px solid #ddd;
  padding: 10px 20px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s ease;
}

.btn-cancel:hover {
  background: #f5f5f5;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .service-header {
    flex-direction: column;
    text-align: center;
  }
  
  .service-actions {
    flex-direction: row;
    justify-content: center;
  }
  
  .principle-content,
  .effects-content {
    grid-template-columns: 1fr;
  }
  
  .feature-grid,
  .target-groups,
  .related-services {
    grid-template-columns: 1fr;
  }
  
  .process-timeline {
    padding-left: 20px;
  }
  
  .timeline-dot {
    left: -27px;
  }
  
  .section {
    padding: 30px 20px;
  }
}
</style>